import { Checkbox } from "@/components/ui/checkbox";

export default function CheckGroup({ label, options, value = [], onChange, testIdPrefix = "chk" }) {
  const toggle = (opt) => {
    if (value.includes(opt)) onChange(value.filter((v) => v !== opt));
    else onChange([...value, opt]);
  };
  return (
    <div className="space-y-2">
      {label && <p className="text-label">{label}</p>}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
        {options.map((opt) => {
          const checked = value.includes(opt);
          return (
            <label
              key={opt}
              className={`tap-target flex items-center gap-3 p-3 rounded-md border-2 transition-colors cursor-pointer ${
                checked ? "border-primary bg-primary/5" : "border-border bg-white hover:bg-secondary"
              }`}
              data-testid={`${testIdPrefix}-${opt.replace(/\s+/g, "-").toLowerCase()}`}
            >
              <Checkbox
                checked={checked}
                onCheckedChange={() => toggle(opt)}
                className="h-6 w-6"
              />
              <span className="text-base font-medium">{opt}</span>
            </label>
          );
        })}
      </div>
    </div>
  );
}
